import { render, staticRenderFns } from "./BankTransferDetailDialog.vue?vue&type=template&id=21e63626&"
import script from "./BankTransferDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BankTransferDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferDetailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports